export default __webpack_public_path__ + "static/media/Highlord's Bolts.7da5f546.jpg";